import React from 'react';
import {NewDeviceBanner} from 'app/components/banner/NewDeviceBanner';
import {useSelector} from 'react-redux';
import {selectCurrentUser, selectFollowedEntities} from 'app/hooks/reduxCreateSelectorHooks';
import {NotSupportedBanner} from 'app/components/banner/NotSupportedBanner';
import {NoDeviceBanner} from 'app/components/banner/NoDeviceBanner';

const SidebarNotification = ({closeSidebar}) => {
  const {messagingDeviceToken, pushSupport, notificationPermission, devices} = useSelector(selectCurrentUser);
  const listOfFollowedEntities = useSelector(selectFollowedEntities);

  const hasPushedEntity = !!listOfFollowedEntities.find(entity => entity.push);

  let Banner = null;
  if (hasPushedEntity) {
    if (!pushSupport) {
      Banner = <NotSupportedBanner />;
    } else if (!messagingDeviceToken && notificationPermission === 'default') {
      Banner = <NewDeviceBanner />;
    } else if (!devices.length && (notificationPermission === 'denied' || notificationPermission === 'deactivated')) {
      Banner = <NoDeviceBanner closeSidebar={closeSidebar} />;
    }
  }

  return Banner;
};

export {SidebarNotification};
